import { ErrorName } from "../type/enums";

export const amplifyErrors = {
    [ErrorName.INCORRECT_CODE]: 'The code you entered is incorrect. Please try again.',
    [ErrorName.SIGNIN_EXCEPTION]: 'You probably refreshed the page during the login process. Please try again.',
    [ErrorName.NOT_AUTHORIZED_EXCEPTION]: 'Your session has expired. Please try again.',
    [ErrorName.NO_SESSION]: 'Failed to fetch authentication session. Please try again.',
}

export class BaseError extends Error {
    public readonly name: ErrorName;
    constructor(message: string, name: ErrorName) {
        super(message);
        this.name = name;
      }
}